import React from "react";
import { useI18n } from "Hooks";

import { Tooltip, IconButton } from "@toddle-edu/ds-web";
import { InformationOutlined } from "@toddle-edu/ds-icons";

const styles = {
  overlayInnerStyle: {
    maxWidth: "240px",
    whiteSpace: "pre-line",
  },
  textCenter: {
    textAlign: "center",
  },
};

const TOOLTIP_LABEL_MAP = {
  displayRole: "configuration:staff_perm_display_title_tooltip",
  permissions: "configuration:staff_perm_permissions_tooltip",
};

const ColumnTooltip = props => {
  const {
    column: { id, metadata: { curriculumAcronym = "" } = {} },
  } = props;
  const { t } = useI18n(["configuration"]);

  const tooltip = t(TOOLTIP_LABEL_MAP[id], {
    curriculum: curriculumAcronym,
  });

  const overlayInnerStyle = {
    ...styles.overlayInnerStyle,
    ...(id === "displayRole" && styles.textCenter),
  };

  return (
    <Tooltip
      tooltip={tooltip ?? ""}
      placement="bottom"
      overlayInnerStyle={overlayInnerStyle}
    >
      <IconButton
        icon={<InformationOutlined variant="on" />}
        variant="dark"
        size="medium"
      />
    </Tooltip>
  );
};

export default ColumnTooltip;
